angular.module('bmsApp.crm.enquiry').controller('EnquiryIndexCtrl', function ($q,
                                                                              $state,
                                                                              $scope,
                                                                              $cookies,
                                                                              ngTableParams,
                                                                              $ngBootbox,
                                                                              notify,
                                                                              EmailSvc,
                                                                              EnquirySvc,
                                                                              EnquiryStatusSvc,
                                                                              InstanceSvc,
                                                                              $localStorage,
                                                                              LicenseOptionsSvc) {


    $scope.loading = true;
    $scope.updating = true;
    $scope.ecomEnabled = InstanceSvc.instance.ecomEnabled();

    $scope.init = function () {
        var promises = {
            statusOptions: EnquiryStatusSvc.options(),
            licenseOptions: LicenseOptionsSvc.license(),
            licenceTypeOptions: LicenseOptionsSvc.network(),
        };
        $q.all(promises)
            .then(function (response) {

                $scope.statusOptions = response.statusOptions.data.options;
                $scope.licenseOptions = response.licenseOptions.data.options;
                $scope.licenseTypeOptions = response.licenceTypeOptions.data.options;
                $scope.loading = false;
            });
        $scope.loading = false;
    };
    $scope.init();

    var defaultEnquiryParams = function () {
        return {
            page: 1, // show first page
            count: $scope.config.table.params.count, // count per page
            sorting: {
                id: 'asc' // initial sorting
            },
            filter: {
                search: '',
                status: ["New"],
                withoutCleansed: true,
                deleted: false,
                licence: null,
                licenceType: null,
            }
        }
    };

    var initialEnquiryParams = function () {
        if (angular.isDefined($localStorage.enquiryIndexParams)) {
            return angular.extend({}, defaultEnquiryParams(), $localStorage.enquiryIndexParams);
        } else {
            return angular.extend({}, defaultEnquiryParams());
        }
    };

    var params = initialEnquiryParams();

    // copy the filters to a workable state
    $scope.enquiryFilters = angular.copy(params.filter);

    $scope.tableParams = new ngTableParams(params, {
        total: 0, // length of data
        counts: $scope.config.table.settings.counts, // available page counts
        getData: function ($defer, params) {
            $scope.updating = true;
            $localStorage.enquiryIndexParams = params.$params;
            EnquirySvc.index(params.$params)
                .then(function (response) {
                    params.total(response.data.enquiry_filtered_count);
                    $defer.resolve(response.data.enquiry_collection);
                    $scope.$emit('enquiryIndexUpdated', {
                        enquiry_collection: response.data.enquiry_collection,
                        enquiry_filtered_count: response.data.enquiry_filtered_count,
                        enquiry_total_count: response.data.enquiry_total_count
                    });
                    $scope.enquiry_filtered_count = response.data.enquiry_filtered_count;
                    $scope.enquiry_total_count = response.data.enquiry_total_count;

                    // Check if we've exceeded our page size, if we have, go back
                    if (response.data.enquiry_filtered_count > 0 && !response.data.enquiry_collection.length) {
                        let newParams = angular.copy($scope.tableParams.$params);
                        newParams.page--;
                        angular.extend($scope.tableParams.$params, newParams);
                    }
                    $scope.updating = false;
                });
        }
    });

    // Store the table params whenever anything changes
    $scope.$watch('tableParams.$params', function (value) {
        if (angular.isObject(value)) {
            $cookies.enquiryIndexParams = JSON.stringify(value);
        }
    }, true);

    $scope.filterApply = function () {
        angular.extend($scope.tableParams.$params.filter, angular.copy($scope.enquiryFilters));
    };

    $scope.rowClicked = function (enquiry) {
        $state.go('main.crm.enquiry.index.view', {
            enquiryId: enquiry.id
        });
    };

    $scope.delete = function (enquiry) {
        $ngBootbox.confirm('Are you sure you want to remove this enquiry? This can not be undone.')
            .then(function () {
                EnquirySvc.delete(enquiry.id)
                    .then(function (response) {
                        notify({
                            message: 'Enquiry deleted successfully'
                        });
                        $scope.tableParams.reload();
                    }, function (error) {
                        notify({
                            message: 'Enquiry deleted successfully',
                            classes: 'error'
                        });
                    });
            });
    };

    // text search
    $scope.filterChanged = function () {
        $scope.tableParams.$params.filter.search = $scope.enquiryFilters.search;
    };

    $scope.emailForm = function (emailAddress, objectType, objectId, enquiry) {
        var email = {
            to: emailAddress,
            object_type: objectType,
            object_id: objectId
        };
        EmailSvc.showSendModal(email, enquiry);
    };

    $scope.$on('enquiryIndexExport', function () {
        var params = angular.copy($scope.tableParams.$params);
        EnquirySvc.export(params);
    });

});